import { render, staticRenderFns } from "./WheelchairIcon.vue?vue&type=template&id=22d58638&scoped=true"
import script from "./WheelchairIcon.vue?vue&type=script&lang=ts"
export * from "./WheelchairIcon.vue?vue&type=script&lang=ts"
import style0 from "./WheelchairIcon.vue?vue&type=style&index=0&id=22d58638&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22d58638",
  null
  
)

export default component.exports